module.exports = __webpack_public_path__ + "img/1536100599.2f5a900d.jpg";